/**
 * EventAbout — what the event is, and where.
 *
 * The event's NAME is this section's heading, not "About this event", with the
 * city directly under it. The hero says both too, over the cover image — and
 * that is exactly why they are repeated here: overlay text is only readable
 * when the image behind it is dark, and an organiser who uploads a white
 * photograph gets white on white. This card's own background always reads.
 *
 * State, country and pincode stay below as labelled rows, each only when the
 * event carries that value. The city is not among them — it is the line under
 * the heading, and printing it twice in one card helps nobody.
 */

import React from 'react';
import { ProseParagraph } from './EventProseSection';

export default function EventAbout({
  title, description, city, state, country, pincode, officialWebsiteUrl,
}) {
  const rows = [
    ['State', state],
    ['Country', country],
    ['Pincode', pincode],
  ].filter(([, value]) => value && String(value).trim());

  return (
    <section className="evb-sec">
      {/* <h2 className="evb-h evb-h--title">{title}</h2> */}
      <ProseParagraph as="h2" className="evb-h evb-h--title" text={title} lines={3} />
      {city && <p className="evb-where__line">{city}</p>}

      {/* <p className="evb-p">{description}</p> */}
      {/* <ProseParagraph text={description} /> */}
      {/* `rich`: the description is written with a formatting toolbar and stores
          HTML. A description saved before that existed has no markup and is
          still rendered as text, by the same component. */}
      {/* 20 lines, not the shared default of 10: an event's description is the
          one piece of prose a reader came for, and most of them now fit whole.
          Set HERE rather than on ProseParagraph, so the category descriptions
          and the prose sections below keep their own shorter clamp. */}
      <ProseParagraph rich text={description} lines={20} />

      {rows.length > 0 && (
        <div className="evb-where">
          {rows.map(([label, value]) => (
            <div key={label}><span>{label}</span><b>{value}</b></div>
          ))}
        </div>
      )}

      {officialWebsiteUrl && (
        <a className="evb-link" href={officialWebsiteUrl}>Official event website</a>
      )}
    </section>
  );
}
